import {
  Button,
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
  Typography,
} from "@material-ui/core";
import MaterialDatatable from "material-datatable";
import React, {useEffect, useState} from "react";
import { useHistory } from "react-router";
import NavDrawer from "./NavDrawer";
import axios from "axios";
import moment from "moment";

const SPACED_DATE_FORMAT = "DD MMM YYYY";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingTop: theme.spacing(6),
    boxSizing: "initial",
  },
  main: {
    display: "flex",
    flexWrap: "wrap",
    margin: `${theme.spacing(0)} auto`,
    paddingTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    justifyContent: "space-around",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  mainListSection: {
    display: "flex",
    flexWrap: "wrap",
    margin: `${theme.spacing(0)} auto`,
    justifyContent: "space-around",
    textDecoration: "underline",
  },
  addBtn: {
    background: "#FF6B00 !important",
    color: "#fff",
    "&:hover": {
      background: "#FF6B00 !important",
    },
  },
  commentsTitle: {
    fontWeight: 900,
    fontVariant: "small-caps",
    letterSpacing: "2px",
    color: "#FF6000",
  },
  commentArchiveList: {
    cursor: "pointer",
  },
  commentExport: {
    cursor: "pointer",
  },
}));

const Comments = () => {
  const classes = useStyles();
  const history = useHistory();

  const [feedbackArr, setFeedbackArr] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/feedback`)
      .then((res) => {
        const allFeedback = res.data.feedback;
        setFeedbackArr(allFeedback);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const columns = [
    {
      name: "Feedback",
      field: "content",
      options: {
        // width: "400px",
        filter: true,
        sort: true,
      },
    },

    {
      name: "Article",
      field: "postTitle",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Name",
      field: "name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Email",
      field: "email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Submitted On",
      field: "date",
      options: { filter: true, sort: false, customBodyRender: value =>
          moment(new Date(value.date)).format(SPACED_DATE_FORMAT) },
    },
  ];

  const options = {
    filter: false,
    onRowsDelete: (rowsDeleted) => {
      const array = rowsDeleted.data;
      array.forEach(({ rowIndex, dataIndex }) => {
        console.log(rowIndex, dataIndex);
        const feedback_id = feedbackArr[dataIndex]._id;
        console.log("ID IS :", feedback_id);
        axios
          .post(`${process.env.REACT_APP_BASE_URL}api/feedback/delete-feedback/${feedback_id}`)
          .then((res) => {
            console.log("RESPONSE IS", res);
            console.log("Feedback Successfully deleted");
          });
      });
    },
  };
  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTypography: {
          root: {
            fontFamily: "Montserrat !Important",
            color: "#000",
            fontSize: 20,
            fontWeight: 700,
            fontVariant: "small-caps",
            letterSpacing: "2px",
          },
        },
        MuiTableCell: {
          root: {
            fontSize: 16,
            fontVariant: "small-caps",
            fontFamily: "Montserrat !Important",
          },
        },
        MaterialDatatableToolbar: {
          root: {
            fontFamily: "Montserrat !Important",
            background: "#F2F2F2",
          },
        },

        MuiTableHead: {
          root: {
            fontWeight: 700,
            fontSize: 16,
          },
        },
        MaterialDatatableToolbarSelect: {
          deleteIcon: {
            color: "red",
          },
          title: {
            color: "#000 !important",
          },
        },

        MuiIconButton: {
          root: {
            color: "#2B2828",
          },
        },
      },
    });

  return (
    <>
      <div className={classes.root}>
        <NavDrawer />
        <div className={classes.content}>
          <div className={classes.main}>
            <Typography className={classes.commentsTitle} variant="h4">
              Feedback Management
            </Typography>
            {/*<Button*/}
            {/*  variant="contained"*/}
            {/*  size="large"*/}
            {/*  className={classes.addBtn}*/}
            {/*  onClick={() => {*/}
            {/*    // history.push("/add-new-post");*/}
            {/*  }}*/}
            {/*>*/}
            {/*  Active*/}
            {/*</Button>*/}
          </div>
          {/* <div className={classes.mainListSection}>
            <Typography className={classes.commentArchiveList}>
              Archive List
            </Typography>
            <Typography className={classes.commentExport}>
              Export Feedback
            </Typography>
          </div> */}
          <div className={classes.main}>
            <div style={{ width: "100%" }}>
              <MuiThemeProvider theme={getMuiTheme()}>
                <MaterialDatatable
                  title={"Feedback Management"}
                  data={feedbackArr}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Comments;
